// ✅ Function to block Shopify's AJAX tracking on the search field
function disableShopifyAjaxOnSearch() {
    document.querySelectorAll(".filter-search").forEach(function (searchInput) {
        searchInput.setAttribute("autocomplete", "off");
        searchInput.setAttribute("data-no-ajax", "true"); // Prevents Shopify from tracking it
        searchInput.setAttribute("form", "none"); // Stops Shopify from auto-submitting

        // Make sure Shopify doesn't override our event listeners
        searchInput.removeEventListener("input", handleFilterSearch);
        searchInput.removeEventListener("keydown", stopPropagation);

        // Reattach event listeners
        searchInput.addEventListener("keydown", stopPropagation);
        searchInput.addEventListener("input", handleFilterSearch);
    });
}

// ✅ Prevents event bubbling (fixes conflicts)
function stopPropagation(event) {
    event.stopPropagation();
}

// ✅ Handles the search filter logic
function handleFilterSearch(event) {
    event.preventDefault();
    event.stopPropagation();

    let searchValue = normalizeText(this.value.toLowerCase());
    let filterGroup = this.closest(".filter-group");
    let filterOptions = filterGroup.querySelectorAll(".sidebar__item");

    let showMoreButton = filterGroup.querySelector("[data-show-more]");

    if (showMoreButton) {
        showMoreButton.click();
    }

    filterOptions.forEach(function (option) {
        let label = option.querySelector("label").innerText;
        let normalizedLabel = normalizeText(label.toLowerCase());

        option.style.display = normalizedLabel.includes(searchValue) ? "block" : "none";
    });
}

// ✅ Normalize text (removes accents)
function normalizeText(text) {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

// ✅ Detect when Shopify reloads products via AJAX and reinitialize search
function observeFilterUpdates() {
    const filterContainer = document.querySelector(".collection__filters");

    if (!filterContainer) return;

    const observer = new MutationObserver(() => {
        setTimeout(disableShopifyAjaxOnSearch, 200); // Ensure Shopify tracking is removed
    });

    observer.observe(filterContainer, { childList: true, subtree: true });
}

// ✅ Force Shopify to reapply fix after every AJAX update
function forceFixAfterAjax() {
    disableShopifyAjaxOnSearch();
    observeFilterUpdates();

    // Listen for Shopify section updates
    document.addEventListener("shopify:section:load", function () {
        setTimeout(disableShopifyAjaxOnSearch, 200);
    });

    // Listen for URL changes (Shopify AJAX navigation)
    let lastUrl = location.href;
    new MutationObserver(() => {
        if (location.href !== lastUrl) {
            lastUrl = location.href;
            setTimeout(disableShopifyAjaxOnSearch, 200);
        }
    }).observe(document.body, { childList: true, subtree: true });
}

// ✅ Run the fix when the page loads
document.addEventListener("DOMContentLoaded", forceFixAfterAjax);

// Zoom mobile/PC
document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 768) {
        document.querySelectorAll(".pswp__button--arrow--left, .pswp__button--arrow--right").forEach(el => el.remove());
    }
});

